// extracted by css-extract-rspack-plugin
export default {"backToLink":"VotNTzG2egc9sygY","body":"NqxMAReFRQxH8NoM","codeSection":"JG1UtmMSmIVtVlx5"};